import { render, staticRenderFns } from "./ScreenLanguage.vue?vue&type=template&id=7e5f6c58"
import script from "./ScreenLanguage.vue?vue&type=script&lang=js"
export * from "./ScreenLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports